module.exports = __webpack_public_path__ + "img/indicado_clima_hover.87685422.png";